export const LOYALTY_PROGRAM_BY_QRCODES_PATH =
  "/loyaltyprogram/loyaltyprogram/qrcodes";
export const USERS_ASSCOAITED_TO_BUSINESS_PATH =
  "/users/rewardlebasic/businessmembers";
export const BUSINESS_TOTAL_CHECKINS_AND_POINTS_PATH =
  "/loyaltyprogram/rewardlebasic/all/points";
export const BUSINESS_CHECKINS_AND_POINTS_PATH =
  "/loyaltyprogram/rewardlebasic/points";
export const BUSINESS_REWARD_ISSUED_PATH =
  "/loyaltyprogram/rewardlebasic/rewards";
export const BUSINESS_REDEEMED_REWARD_PATH =
  "/loyaltyprogram/rewardlebasic/rewardsredeemed";
export const BUSINESS_SOCIAL_AMPLIFIER_PATH =
  "/users/rewardlebasic/businesssocialamplifier";
export const IS_REWARDLE_BASIC_BUSINESS_PATH = "/users/rewardlebasic/email";
export const UPDATE_BUSINESS_PATH = "/datacollection/v1/business/businessauth";
export const BUSINESS_LOYALTYPROGRAM_PATH =
  "/loyaltyprogram/loyaltyprograms/business";
export const UPDATE_BUSINESS_LOYALTYPROGRAM_PATH =
  "/loyaltyprogram/loyaltyprogram/business";
export const BUSINESS_REWARDLIST_PATH = "/loyaltyprogram/businessreward";
export const BUSINESS_REWARD_PATH = "/loyaltyprogram/businessreward/business";
export const BUSINESS_FEATURE_MENU_PATH =
  "/billingplatformnode/menu/businessadmin";
export const GET_BUSINESS_MEMBERS_PATH = "/businessmembers/users";
export const GET_REWARDLE_PAYMENT_REPORT_PATH =
  "/rewardlepay/business/transactions/report";
export const GET_FEATURES_FOR_BUSINESS_PATH =
  "/billingplatformnode/business/featuremaster";

// Redis business toggle check
export const REDIS_BUSINESS_GET_PATH = "/utilities/business/redis/get";

// Billing / Contract status (used for restriction)
export const BILLING_DETAILS_PATH = "/billingplatform-business/billingdetails";

// Portal Members API paths
export const GET_MEMBERS_PATH = "/loyaltyprogram/businessportal/memberships";
export const SEARCH_MEMBERS_PATH = "/loyaltyprogram/businessportal/business";
export const GET_USER_BY_ID_PATH = "/users/businessportal/user";
export const ADD_CREDIT_PATH = "/loyaltyprogram/businessportal/credits";
export const ADD_POINTS_PATH = "/loyaltyprogram/businessportal/points";

// Portal Rewards API paths
export const GET_REWARDS_PATH = "/loyaltyprogram/businessportal/rewards";
export const CREATE_REWARD_PATH = "/loyaltyprogram/businessportal/reward";
export const UPDATE_REWARD_PATH = "/loyaltyprogram/businessportal/reward";
export const GET_REWARDLE_TYPES_PATH = "/loyaltyprogram/businessportal/rewardletypes";

// Portal Programs API paths
export const GET_PROGRAMS_PATH =
  "/loyaltyprogram/businessportal/loyaltyprograms";
export const CREATE_PROGRAM_PATH =
  "/loyaltyprogram/businessportal/loyaltyprogram";
export const UPDATE_PROGRAM_PATH =
  "/loyaltyprogram/businessportal/loyaltyprogram";

// Portal QR Code API paths
export const GET_JOIN_QRCODE_PATH =
  "/loyaltyprogram/businessportal/qrcode/join";
export const GENERATE_JOIN_QRCODE_PATH =
  "/loyaltyprogram/businessportal/qrcode/join";
export const SAVE_JOIN_REWARD_PATH =
  "/loyaltyprogram/businessportal/qrcode/join/reward";